export class DscCredential {
    private userName: string;
    private password: string;
    private domainName?: string;

    constructor(userName: string, password: string, domainName?: string) {
        this.userName = userName;
        this.password = password;
        this.domainName = domainName;
    }

    public toString = (): string => {
        let returnValue: string = '';
        if (this.domainName === '' || this.domainName === undefined) {
            returnValue = `New-Object System.Management.Automation.PSCredential("${this.userName}",
                  (ConvertTo-SecureString "${this.password}" -AsPlainText -Force))`;
        } else {
            returnValue = `New-Object System.Management.Automation.PSCredential("${this.domainName}\\${this.userName}",
                  (ConvertTo-SecureString "${this.password}" -AsPlainText -Force))`;
        }
        return returnValue;
    }
}
